import { useContext } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { connect } from 'react-redux';
import recurlyPaymentTypes from 'src/common/constants/subscription/recurlyPaymentTypes';
import { PAYMENT_FLOW_FORM_LAYOUT_ALT_PAYMENT_TEXT } from 'src/common/constants/localizations/payment';
import { DEVICE } from '../../constants/localizations/auth';

import { selectPartners } from '../../selectors/partners';
import findPartnerInfo from '../../utils/findPartnerInfo';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import cssVariables from '../../styles/variables';
import TuneInMarquee from './svgIcons/TuneInMarquee';

import css from './authAndPaymentFlowHeader.module.scss';

const AuthAndPaymentFlowHeader = ({
  header,
  subheader,
  billingInfo,
  partners,
  isDesktop,
  isPartnerFlow,
}) => {
  const { getLocalizedText, location } = useContext(
    LocationAndLocalizationContext,
  );
  const partnerInfo = findPartnerInfo(location, partners);
  const partnerName = get(partnerInfo, 'name');

  return (
    <div
      data-testid="paymentFlowFormLayoutHeaderContainer"
      className={classnames(css.headerContainer, {
        [css.isPartnerFlow]: isPartnerFlow,
      })}
    >
      {isDesktop && (
        <div id="tuneInLogoContainer" className={css.marqueeContainer}>
          <TuneInMarquee
            width="112px"
            height="50px"
            fill={cssVariables['--ink-dark']}
          />
        </div>
      )}
      <h1
        data-testid="paymentFlowFormLayoutHeader"
        className={classnames(css.header, {
          [css.isPartnerFlow]: isPartnerFlow,
        })}
      >
        {getLocalizedText(
          header,
          isPartnerFlow
            ? {
                partnerName: partnerName || getLocalizedText(DEVICE),
              }
            : undefined,
        )}
      </h1>
      {subheader && !isPartnerFlow && (
        <p
          data-testid="paymentFlowFormLayoutSubHeader"
          className={classnames(css.subheader, {
            [css.isPartnerFlow]: isPartnerFlow,
          })}
        >
          {billingInfo &&
            billingInfo.paymentType === recurlyPaymentTypes.other && (
              <span>
                {getLocalizedText(PAYMENT_FLOW_FORM_LAYOUT_ALT_PAYMENT_TEXT)}
              </span>
            )}
          {getLocalizedText(subheader)}
        </p>
      )}
    </div>
  );
};

AuthAndPaymentFlowHeader.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  billingInfo: PropTypes.object,
  partners: PropTypes.object,
  isDesktop: PropTypes.bool,
  isPartnerFlow: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    isDesktop: get(state, 'app.isDesktop'),
    partners: selectPartners(state),
  };
}

export default connect(mapStateToProps)(AuthAndPaymentFlowHeader);
